var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"sc-progress-steps"},_vm._l((this.steps),function(step,index){return _c('li',{key:index,class:{ 'active' : step.checked },style:(_vm.liStyle)},[_c('span',[_vm._v(_vm._s(step.text))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }